import { render, staticRenderFns } from "./TopCart.vue?vue&type=template&id=3ae825b8"
import script from "./TopCart.vue?vue&type=script&lang=ts"
export * from "./TopCart.vue?vue&type=script&lang=ts"
import style0 from "./TopCart.vue?vue&type=style&index=0&id=3ae825b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports